/* eslint-disable */

import { useState } from "react";
import { Box, Button, FormControl, FormLabel, MenuItem, Select, styled, TextField, CircularProgress } from "@mui/material";
import { ContentBriefWrapper } from "./css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { update } from "lodash";

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&.Mui-selected": { color: theme.palette.primary.main },
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

const StepperContentBriefBody = ({ queryId, contentQuery, formData, updateForm, generateTitleHandlerFromPopUp, loadingTitle, setLoadingTitle }) => {
  const [autoInsert, setAutoInsert] = useState(10);
  const handleChange = event => {
    setAutoInsert(event.target.value);
  };

  return (
    <ContentBriefWrapper>
      <Box className="TopFormWrapper">
        <FormControl className="BasicInput">
          <FormLabel>
            Article Title *{" "}
            <Button
              onClick={() => {
                generateTitleHandlerFromPopUp();
              }}
            >
              <AutoFixHighIcon /> {loadingTitle ? <CircularProgress size={15} sx={{ color: "#fff" }} /> : "Generate"}
            </Button>
          </FormLabel>
          <TextField value={formData.title} onChange={e => updateForm("title", e.target.value)} placeholder="e.g., Best Trail Running Shoes for Women" />
        </FormControl>
        <FormControl className="BasicDropDown" sx={{ minWidth: 160 }}>
          <FormLabel>Content type</FormLabel>
          <Select id="demo-simple-select" value={autoInsert} onChange={e => updateForm("contentType", e.target.value)} IconComponent={ExpandMoreIcon}>
            <CustomMenuItem value={10}>Blog article</CustomMenuItem>
            <CustomMenuItem value={20}>Landing page</CustomMenuItem>
          </Select>
        </FormControl>
        <FormControl className="BasicDropDown" sx={{ width: 160 }}>
          {" "}
          {/* added for the image requirement */}
          <FormLabel>Include images?</FormLabel>
          <Select value={formData.includeImages} onChange={e => updateForm("includeImages", e.target.value)} IconComponent={ExpandMoreIcon}>
            <CustomMenuItem value="yes">Yes</CustomMenuItem>
            <CustomMenuItem value="no">No</CustomMenuItem>
          </Select>
        </FormControl>
        <FormControl className="BasicInput" sx={{ width: 220 }}>
          <FormLabel>Select word count for blog</FormLabel>
          <TextField
            type="number"
            value={formData.wordCount}
            onChange={e => {
              const value = e.target.value;

              // empty allow
              if (value === "") {
                updateForm("wordCount", "");
                return;
              }

              let val = parseInt(value, 10);

              // 🔥 agar current value 0 ya default ho, overwrite karo
              if (formData.wordCount === 0) {
                updateForm("wordCount", val);
                return;
              }

              if (val > 4000) val = 4000;

              updateForm("wordCount", val);
            }}
            onBlur={() => {
              if (formData.wordCount === "") {
                updateForm("wordCount", 2000);
              }
            }}
            inputProps={{ min: 2000, max: 4000, step: 100 }}
          />
        </FormControl>
      </Box>
      <FormControl className="BasicTextarea">
        <FormLabel>Content Requirements</FormLabel>
        <TextField
          onChange={e => updateForm("requirements", e.target.value)}
          id="outlined-multiline-static"
          multiline
          rows={4}
          placeholder="Create a comprehensive guide. Include practical tips, expert insights, and actionable advice. Focus on main benefit and address common pain points. Structure the content with clear headings and examples."
        />
      </FormControl>
    </ContentBriefWrapper>
  );
};

export default StepperContentBriefBody;
